import { NgModule } from "@angular/core";

import { NumericRangeValidatorDirective } from "./numeric-range-validator.directive";

@NgModule({
	imports: [],
	exports: [NumericRangeValidatorDirective],
	declarations: [NumericRangeValidatorDirective],
})
export class NumericRangeValidatorModule {}
